module.exports = __webpack_public_path__ + "static/media/sensor-fire.54ed4e88.svg";